<template>
  <div>
    <el-form
      :model="list"
      :rules="toAdRule"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%; margin: 20px auto"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="楼盘名字" prop="floorName">
            <el-input
              placeholder="请输入内容"
              v-model="list.floorName"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="联系电话" prop="phone">
            <el-input placeholder="请输入内容" v-model="list.phone" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="价格" prop="price">
            <el-input placeholder="请输入内容" v-model="list.price" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="开盘日期" prop="price">
            <el-date-picker
              v-model="list.openDate"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="开盘日期" prop="price">
            <el-date-picker
              v-model="list.openDate"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="内容" prop="content">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="list.content"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="楼盘描述" prop="floorDesc">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="list.floorDesc"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="点赞数" prop="likeCount">
            <el-input
              type="input"
              :rows="10"
              placeholder="请输入内容"
              v-model="list.likeCount"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="类型" prop="type">
            <el-select
              clearable
              placeholder="请选择"
              size="small"
              v-model="list.type"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item
            label="封面图（700*220）"
            prop="coverUrl"
            ref="coverUrl"
          >
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <img
                v-if="list.coverUrl"
                :src="list.coverUrl"
                class="avatar"
                style="width: 150px; height: auto"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          style="margin-left: 200px"
          type="primary"
          @click="submitAdd('ruleForm')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["ChangeData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.coverUrl)
      if (this.list.coverUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false, //加载
      list: "",
      //留言类型--下拉框：
      type: [
        {
          value: 1,
          label: "最新开盘",
        },
        {
          value: 2,
          label: "热门楼盘",
        },
      ],
       serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      toAdRule: {
        floorName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        content: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        price: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        floorDesc: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        phone: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        openDate: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        coverUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        type: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        likeCount: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.list = this.ChangeData;
    console.log(this.ChangeData, "-----");
  },
  watch: {
    ChangeData(newVal, oldVal) {
      this.list = newVal;
    },
  },
  methods: {
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    // 封面图上传成功
    upSuccess(file) {
      this.list.coverUrl = file.entity;
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/houseInfo/update", {
            floorName: this.list.floorName, //楼盘名称名字
            coverUrl: this.list.coverUrl, //封面图
            type: this.list.type, //类型
            content: this.list.content, //内容
            phone: this.list.phone, //手机号
            price: this.list.price, //价格
            floorDesc: this.list.floorDesc, //价格
            openDate: this.formatDateTime(this.list.openDate), //开盘日期
            floorId: this.list.floorId,
            likeCount: this.list.likeCount,
            id: this.list.id,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>